import { thousandsSeparator } from 'helpers/generalHelpers'
import settings, { isRtl } from '../../settings'

const { LOCALE_IN_USE } = settings

const toPersianDigit = (a) => {
  if (a !== null && a !== undefined) {
    if (typeof a === 'number') {
      a = a.toString()
    }

    return a.replace(/\d+/g, function (digit) {
      const enDigitArr = []
      const peDigitArr = []

      for (let i = 0; i < digit.length; i++) {
        enDigitArr.push(digit.charCodeAt(i))
      }

      for (let j = 0; j < enDigitArr.length; j++) {
        peDigitArr.push(
          String.fromCharCode(enDigitArr[j] + (!!a && a === true ? 1584 : 1728))
        )
      }

      return peDigitArr.join('')
    });
  }
  return ''
}

export const digitByLocal = (digit) => {
  return isRtl ? toPersianDigit(digit) : digit
}

export function abbreviateNumber(value) {
  let newValue = value
  if (value >= 1000) {
    var suffixes = ['', 'K', 'M', 'B', 'T']
    var suffixNum = Math.floor(('' + value).length / 3)
    var shortValue = ''
    for (var precision = 2; precision >= 1; precision--) {
      shortValue = parseFloat(
        (suffixNum !== 0
          ? value / Math.pow(1000, suffixNum)
          : value
        ).toPrecision(precision)
      )
      var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g, '')
      if (dotLessShortValue.length <= 2) {
        break
      }
    }
    if (shortValue % 1 !== 0) shortValue = shortValue.toFixed(1)
    newValue = digitByLocal(shortValue) + suffixes[suffixNum]
  }
  return newValue
}

const locales = {
  fa: 'fa-IR',
  en: 'en-US',
}

export const currencies = {
  fa: 'IRR',
  en: 'USD',
}

export const formatNumber = (number) =>
  new Intl.NumberFormat(locales[LOCALE_IN_USE]).format(number)

export const formatCurrency = (number) =>
  digitByLocal(thousandsSeparator(number))
